import styled, { css } from 'styled-components';

export const ReactQuillWrapper = styled.span`
  width: ${props => props.width};

  .ql-editor {
    height: ${({ height }) => height || '100%'};
    max-height: ${({ maxHeight }) => maxHeight && maxHeight};
    padding: ${({ withPaddings }) => withPaddings ? '12px 15px' : '2px 0'};
    padding-right: ${({ withRightIndent }) => withRightIndent ? '60px' : 'auto'};
    word-break: break-word;

    &.ql-blank::before {
      font-size: 13px;
      font-style: normal;
      ${({ viewMode }) => viewMode && css`margin-left: -15px;`};
      color: ${({ theme }) => theme.colors.fontSilverLight};
    }
  }

  .ql-snow .ql-tooltip a.ql-preview {
    vertical-align: middle;
  }

  .ql-snow.ql-disabled {
    border: ${({ viewMode }) => viewMode && 'none'};
  }

  .ql-tooltip {
    z-index: 100;
    left: 0 !important;

    input {
      line-height: 10px;
    }
  }

  .ql-toolbar {
    display: ${({ viewMode }) => viewMode && 'none'};
    position: initial;
    line-height: 1.5;
    padding: 6px;

    &.ql-snow {
      border-radius: 3px 3px 0 0;
      background-color: ${({ theme }) => theme.colors.backgroundLightSilver};
    }
  }

  .ql-container {
    font-size: 14px;
    &.ql-snow {
      border-radius: 0 0 3px 3px;
    }
  }

  .ql-picker-label {
    &:focus {
      outline: none;
    }
  }

  .ql-mention-list-container {
    max-height: 250px;
    overflow-y: scroll;
  }

  .ql-mention-list-item {
    height: auto;
    padding: 8px;
    line-height: 1.5;

    img {
      object-fit: cover;
      border-radius: 50%;
      margin-right: 5px;
    }

    span {
      font-size: 14px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/react-quill/styled-components.js